export const environment = {
  projectName: 'Check_r - acceptance',
  logo: 'assets/img/b12-logo-square.svg',
  showLegalFooter: true,
  production: false,
  test: false,
  BASE_PATH: 'https://app.checkr-acc.b12-consulting.com',
  KEYCLOAK_BASE_PATH: 'https://app.checkr-acc.b12-consulting.com/auth',
  API_BASE_PATH: 'https://app.checkr-acc.b12-consulting.com/api',
  DJANGO_BASE_PATH: '',
  DJANGO_ADMIN_PANEL: '/admin-panel',
  EMAIL_DOMAIN: 'checkr-acc.b12-consulting.com',
  envName: 'acceptance',
};
